export function Methodology({ t }) {
  const items = [
    { icon:'memories',   title:t.methMemoriesTitle,   illus:'3', body:t.methMemoriesBody },
    { icon:'edges',      title:t.methEdgesTitle,      illus:'7', body:t.methEdgesBody },
    { icon:'mistakes',   title:t.methMistakesTitle,   illus:'4', body:t.methMistakesBody },
    { icon:'confidence', title:t.methConfidenceTitle, illus:'2', body:t.methConfidenceBody },
  ];
  return (
    <section id="methodology" style={methStyles.wrap}>
      <div style={methStyles.head}>
        <div style={methStyles.kicker}>{t.methKicker}</div>
        <h2 style={methStyles.h2}>{t.methTitle}</h2>
        <p style={methStyles.lede}>{t.methSub}</p>
      </div>
      <div className="ssi-meth__grid" style={methStyles.grid}>
        {items.map(it => (
          <article key={it.title} className="ssi-meth__card" style={methStyles.card}>
            <img src={`/assets/icon-${it.icon}.svg`} alt="" style={methStyles.icon}/>
            <h3 style={methStyles.cardH}>{it.title}</h3>
            <p className="ssi-meth__cardP" style={methStyles.cardP}>{it.body}</p>
            <img className="ssi-meth__illus" src={`/assets/illus-people-${it.illus}.svg`} alt="" style={methStyles.illus}/>
          </article>
        ))}
      </div>
    </section>
  );
}

const methStyles = {
  wrap: { background:'var(--offWhite)', padding:'96px 32px 64px', maxWidth:1440, margin:'0 auto' },
  head: { textAlign:'center', maxWidth:680, margin:'0 auto 56px' },
  kicker: { fontSize:12, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--brandRed)', fontWeight:600, marginBottom:12 },
  h2: { fontFamily:'var(--font-display)', fontSize:44, lineHeight:1.1, margin:'0 0 12px', letterSpacing:'-.01em' },
  lede: { fontSize:17, color:'var(--grey)', margin:0 },
  grid: { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:18 },
  card: { background:'#fff', border:'1px solid var(--border)', borderRadius:16, padding:'28px 22px 0', position:'relative', overflow:'hidden', minHeight:320 },
  icon: { width:52, height:52, marginBottom:14 },
  cardH: { fontFamily:'var(--font-display)', fontSize:24, margin:'0 0 8px', color:'var(--brandRed)' },
  cardP: { fontSize:14, color:'var(--grey)', lineHeight:1.55, margin:0, paddingBottom:90 },
  illus: { position:'absolute', right:10, bottom:6, width:90, height:'auto', opacity:.85 },
};
